<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Contact/ContactPerson'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl grid xl:grid-cols-2 grid-rows-1 gap-10"
    >
      <div class="flex flex-col gap-7.5 xl:items-start justify-center">
        <span class="text-H2 text-Tekst">
          <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']" />
        </span>
        <div class="flex flex-col">
          <span class="text-H3 text-Tekst"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']" /></span>
          <span class="text-H4 text-Tekst"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_3']" /></span>
        </div>
        <div class="hidden xl:flex flex-col">
          <span class="text-Tekst"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_4']" /></span>
          <span class="text-H4 font-semibold text-Tekst no-underline"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_5']" /></span>
        </div>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
        >
          <AppButton
            :href="link?.href"
            :target="link?.target"
            button-theme="Primary"
            class="xl:hidden flex"
          >
            <div class="flex flex-col xl:flex-row gap-2 items-center">
              <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
            </div>
          </AppButton>
        </CmsLink>
      </div>
      <CmsImage
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'img_1']"
        class="rounded-3xl"
      />
    </div>
  </CmsCustomComponent>
</template>
